import { memo } from "react";
import { FormattedMessage } from "react-intl";
import { Empty } from "components";
import { ICommand } from "../VoiceCommand"
import { publicPath} from "request"

interface ICommandCard {
  commands: ICommand[];
}
export const CommandCard: React.FC<ICommandCard> = memo(({ commands }) => {

  const formateVoices = (voice: string): string[] => {
    return voice ? JSON.parse(voice) : [];
  };

  if (!commands || commands.length === 0) {
    return (
      <Empty
        emptyText={<FormattedMessage id="thirdParty.command.empty.text" />}
      />
    );
  }

  return (
    <div className="pb-1">
      {commands.map((command, key) => (
        <div
          className="bg-white dark:bg-gray323434 rounded-lg mx-3 px-3 py-4 mt-2"
          key={key}
        >
          <div className="flex flex-row items-center gap-3 mb-4">
            <img
              src={`${publicPath}/icons/ic_voice_small.png`}
              alt=""
              className="w-[14px]"
            />
            <span className="font-medium text-sm">{command.title}</span>
          </div>
          {formateVoices(command.command).map((text: string, index: number) => (
            <div
              className="bg-[#F7F7F9] dark:bg-black1b1f1e rounded text-xs px-3 py-3 mt-2"
              key={`${index}-${text}`}
            >
              {text}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
});
